module.exports = __webpack_public_path__ + "img/img28.201021b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img28.jpg
// module id = 325
// module chunks = 0